<template>
  <div class="construct">
    <div class="constructBox">
      <div class="left">
        <div class="leftBox">
          <div class="LBTitle">
            添加模块
          </div>
          <div class="leftItem" @click="addContnt(1)">
            <i class="el-icon-edit-outline"></i>
            <div>文本</div>
          </div>
          <div class="leftItem" @click="addContnt(2)">
            <i class="el-icon-picture"></i>
            <div>图片</div>
          </div>
        </div>
        <div class="leftBox">
          <div class="LBTitle">
            使用选中模块({{ productDescribe.length }})
          </div>
          <div class="LContent">
            <draggable v-model="productDescribe" @start="drag = true" @end="drag = false">
              <div :class="activeIndex == index ? 'active' : ''" class="item" v-for="(item, index) in productDescribe"
                @click="activeClick(item, index)" :key="index">
                <div class="text">
                  <div>
                    <i class="el-icon-s-unfold"></i>
                    {{ item.type == 'text' ? '文字' : '图片' }}
                  </div>
                  <div class="operate">
                    <i class="el-icon-document-copy" @click.stop="copyItem(item, index)"></i>
                    <i class="el-icon-delete" @click.stop="deleteItem(index)"></i>
                  </div>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </div>
      <div class="content">
        <draggable v-model="productDescribe" @start="drag = true" @end="drag = false">
          <div :class="activeIndex == index ? 'active' : ''" class="item" v-for="(item, index) in productDescribe"
            @click="activeClick(item, index)">
            <div class="text" v-if="item.type == 'text'">
              <div v-if="item.contentList[0].text != ''"
                :style="`text-align:${item.contentList[0].textModuleDetails.align};font-size:${item.contentList[0].textModuleDetails.fontSize}px;background:${item.contentList[0].textModuleDetails.backgroundColor};color:${item.contentList[0].textModuleDetails.fontColor};`">
                {{ item.contentList[0].text }}
              </div>
              <div v-else style="display: flex;justify-content: center;">
                <i class="el-icon-edit-outline" style="font-size: 46px;color: #dcdcdc;margin: 20px auto;"></i>
              </div>
            </div>
            <div class="text" v-else>
              <img class="img" :src="item.contentList[0].imgUrl" alt="" srcset=""  v-if="item.contentList[0].imgUrl != ''">
              <div v-else style="display: flex;justify-content: center;">
                <i class="el-icon-picture" style="font-size: 46px;color: #dcdcdc;margin: 20px auto;"></i>
              </div>
            </div>
          </div>
        </draggable>
      </div>
      <div class="right">
        <div class="rightText" v-if="Info.type == 'text'">
          <el-input type="textarea" v-model="Info.contentList[0].text" :maxlength="500" show-word-limit
            style="margin-bottom: 10px;">
          </el-input>
          <el-input type="number" v-model="Info.contentList[0].textModuleDetails.fontSize">
            <template slot="prepend">字体大小：</template>
          </el-input>
          <el-input type="color" v-model="Info.contentList[0].textModuleDetails.backgroundColor">
            <template slot="prepend">背景色：</template>
          </el-input>
          <el-input type="color" v-model="Info.contentList[0].textModuleDetails.fontColor">
            <template slot="prepend">字体颜色：</template>
          </el-input>
          <div style="margin-bottom: 10px;">
            <el-radio v-model="Info.contentList[0].textModuleDetails.align" label="left">左对齐</el-radio>
            <el-radio v-model="Info.contentList[0].textModuleDetails.align" label="center">居中</el-radio>
            <el-radio v-model="Info.contentList[0].textModuleDetails.align" label="right">右对齐</el-radio>
            <el-radio v-model="Info.contentList[0].textModuleDetails.align" label="justify">两端对齐</el-radio>
          </div>
          <!-- <el-button style="width: 100%;" type="danger" @click="del">删除</el-button> -->
        </div>
        <div v-if="Info.type == 'image'">
          <!-- <el-input type="number" v-model="Info.color">
            <template slot="prepend">高度：</template>
          </el-input> -->
          <el-upload class="avatar-uploader" action="#" :show-file-list="false" :http-request="upload"
            :before-upload="beforeUpload">
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="font-size: 14px;color: #9999;">
            0.5≤[图片宽÷图片高]≤2, 宽度≥480, 高度 ≥480，上传图片大小限制在3M以内
          </div>
          <!-- <el-button style="width: 100%;" type="danger" @click="del">删除</el-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import galleryApi from '@/api/moudles/gallery'
export default {
  components: {
    draggable
  },
  props: {
    storeId: {
      type: String,
      default: ''
    },
    classId: {
      type: String,
      default: ''
    },
    productDescribe: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      // constructData: [],
      activeIndex: 999,
      Info: {}
    }
  },
  computed: {
  },
  mounted() {
    // console.log(window.location.hash.slice(0))
  },
  methods: {
    upload(e) {
      console.log("===-===")
      let file = e.file;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // console.log(reader.result); // base64
        let imageUrlSet = ''
        if (reader.result.includes('data:image/jpeg;base64,')) {
          imageUrlSet = reader.result.split('data:image/jpeg;base64,')[1]
        }

        if (reader.result.includes('data:image/png;base64,')) {
          imageUrlSet = reader.result.split('data:image/png;base64,')[1]
        }
        let params = {
          "shopId": this.storeId,
          "image": imageUrlSet,
          "imageBizType": 0,
          "options": { "boost": "true", "cateId": Number(this.catId), "doIntelligenceCrop": "true", "sizeMode": 0 }
        }

        galleryApi
          .uploadGoodsImage(params)
          .then(res => {
            if (res.errorCode === 1000000) {
              console.log("===1===")
              this.productDescribe[this.activeIndex].contentList[0].imgUrl = res.result.imageUrl
              // resolve(self.isStatus ? res.result.urls[0] : res.result.imageUrl)
            } else {
              this.$message.error(res.errorMsg)
              // reject(null)
            }
          })
      }
      reader.onerror = function (err) {
        console.log(err);
      }
    },
    beforeUpload(file) {
      console.log(file)
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 3;

      if (!isJPG) {
        this.$message.error('请上传JPG、PNG格式照片!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 3MB!');
      }
      return isJPG && isLt2M;
    },
    copyItem(item, index) {
      const newArray = [...this.productDescribe.slice(0, index), item, ...this.productDescribe.slice(index)];
      this.productDescribe = newArray
    },
    deleteItem(index) {
      this.productDescribe.splice(index, 1)
      if (this.activeIndex == index) {
        this.Info = {}
        this.activeIndex = 999
      }
    },
    activeClick(item, index) {
      this.Info = item
      this.activeIndex = index
    },
    addContnt(index) {
      let obj = {}
      if (index == 1) {
        obj = {
          "contentList": [
            {
              "height": 62, //图片高度--通用，高度最小480px
              "text": "", //文字信息--文字模块，文本-text必填，长度限制500字符内
              "textModuleDetails": {
                "align": "left", //文字对齐方式，left--左对齐；right--右对齐；center--居中；justify--两端对齐文本-text必填
                "backgroundColor": "#FFFFFF", //背景颜色文本-text必填，六位值，例#ffffff
                "fontColor": "#000000", //文字颜色文本-text必填，六位值，例#333333
                "fontSize": 12 //文字模块字体大小文本-text必传12
              }, //文字模块详情文本-text必填
              "width": 750 //图片宽度--通用，宽度最小480px
            }
          ], //楼层内容
          "floorId": null, //楼层id,null:新增,否则为更新
          "key": "DecImage", //楼层类型的key,目前默认传'DecImage'
          "lang": "en", //语言类型
          "priority": 0, //楼层排序
          "type": "text" //组件类型type,图片-image,文本-text
        }
      } else if (index == 2) {
        obj = {
          "contentList": [
            {
              "height": 2000, //图片高度--通用，高度最小480px
              "imgUrl": "", //图片地址--通用，图片最大3M
              "width": 2000 //图片宽度--通用，宽度最小480px
            }
          ], //楼层内容
          "floorId": null, //楼层id,null:新增,否则为更新
          "key": "DecImage", //楼层类型的key,目前默认传'DecImage'
          "lang": "en", //语言类型
          "priority": 1, //楼层排序
          "type": "image" //组件类型type,图片-image,文本-text
        }
      }
      this.productDescribe.push(obj)
    }
  }
}
</script>

<style lang="scss" scoped>
.constructBox {
  display: flex;
  justify-content: center;
}

.left {
  width: 200px;
}

.leftBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;

  .LBTitle {
    width: 100%;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .LContent {
    width: 100%;

    .text {
      width: 100%;
      border: 1px solid #dcdcdc;
      margin-bottom: 10px;
      padding: 5px 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      .operate {
        display: none;

        i {
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }

    .text:hover {
      .operate {
        display: block;
      }
    }

    .active .text {
      border-color: #66b1ff;
      background: #66b0ff14;
    }
  }
}

.leftItem {
  width: 48%;
  padding: 10px 0px;
  padding-top: 0px;
  cursor: pointer;
  text-align: center;
  display: flex;

  i {
    font-size: 50px;
    margin-right: 5px;
  }
}

.right {
  width: 400px;

  .rightText .el-input {
    margin-bottom: 10px;
  }
}

.content {
  width: 375px;
  margin: 0 20px;
  border: 1px solid #dcdcdc;
  padding: 20px;

  .item {
    width: 100%;
    margin-bottom: 10px;
  }

  .text {
    width: 100%;
    /* height: 50px; */
    border: 1px solid #dcdcdc;
    padding: 5px;
  }

  .img {
    width: 100%;
    height: 375px;
    // border: 1px solid #dcdcdc;
    // padding: 5px;
  }

  .active .text,
  .active .img {
    border-color: #66b1ff;
  }

}


/deep/.el-textarea__inner {
  background-color: transparent !important;
  color: inherit !important;
}

/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 10px;
}

/deep/.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

/deep/.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/deep/.el-textarea__inner {
  height: 200px;
}
</style>
